import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";

import { callGet, callPost } from "../../http_client";

import { fetchLogout, tokenFetchError, tokenFetchRequest, tokenFetchSuccess } from "./actions";
import { expireApiToken, setApiToken } from "./side_effects";
import { AuthActionTypes } from "./types";

export function* handleTokenFetch(action: ReturnType<typeof tokenFetchRequest>): SagaIterator {
  try {
    const res = yield call(callPost, "/auth/token/", action.payload);
    const { token } = res.data;
    yield call(setApiToken, token);
    yield put(tokenFetchSuccess(token));
  } catch (err) {
    yield put(tokenFetchError(err.response.data.detail));
  }
}

export function* handleFetchLogout(action: ReturnType<typeof fetchLogout>): SagaIterator {
  yield call(callGet, "/auth/logout/");
  yield call(expireApiToken);
}

function* watchAuthSagas(): SagaIterator {
  yield takeLatest(AuthActionTypes.FETCH_REQUEST, handleTokenFetch);
  yield takeLatest(AuthActionTypes.LOGOUT, handleFetchLogout);
}

export default watchAuthSagas;
